<template>
  <div class="content">
    <div>
      开通动态验证：
      <a-switch
        v-if="checked !== null"
        :checked="checked"
        @change="onChange"
        :loading="loading"
      />
    </div>
    <div style="margin:15px 5px">
      <p v-if="checked">此账号已开通动态验证，请关注“联大学堂”公众号进行身份认证，并获取动态验证码</p>
    </div>
    <div style="margin: 20px 0" v-if="checked && MFAImg">
      <div><img class="MFAImg" :src="MFAImg" /></div>
      <div style="margin: 20px 0">
        <span
          >绑定虚拟MFA后，您可以在登录时通过它来进行二次校验或找回密码。</span
        >
      </div>
      <div class="explain">
        <div style="margin: 20px 0">
          <span>如何使用？</span>
          <br />
          <div class="download-url">
            <div class="image-div">
              <img
                class="download-app-image"
                src="@/assets/images/IOS1.png"
                alt=""
                srcset=""
              /><br />
              <span>IOS</span>
            </div>
            <div class="image-div">
              <img
                class="download-app-image"
                src="@/assets/images/Android.png"
                alt=""
                srcset=""
              /><br />
              <span>Android</span>
            </div>
          </div>
          <span>推荐使用Authenticator绑定虚拟MFA</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SecuritySettingtab3",
  data: function () {
    return {
      checked: null,
      loading: false,
      MFAImg: null,
    };
  },
  created() {
    this.getMFAStatus();
  },
  methods: {
    getMFAStatus() {
      this.axios.get(`/biz/user/totp/get`).then((res) => {
        if (res.result) {
          // this.MFAImg = res.result.jpg;
          this.checked = true;
        } else {
          this.checked = false;
        }
      });
    },
    onChange(checked) {
      this.loading = true;
      if (checked) {
        this.openMFA();
      } else {
        this.closeMFA();
      }
      console.log(`a-switch to ${checked}`);
    },
    openMFA() {
      this.axios
        .get(`/biz/user/totp/enable`)
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.checked = true;
            this.MFAImg = null;
            this.getMFAStatus();
            this.$message.success("开启成功");
          } else {
            this.loading = false;
            this.checked = false;
            this.$message.error("开启失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.checked = false;
          this.$message.error("开启失败");
        });
    },
    closeMFA() {
      this.axios
        .get(`/biz/user/totp/disable`)
        .then((res) => {
          if (res.success) {
            this.loading = false;
            this.checked = false;
            this.$message.success("关闭成功");
          } else {
            this.loading = false;
            this.checked = true;
            this.$message.error("关闭失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.checked = true;
          this.$message.error("关闭失败");
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.content {
  background: #fff;
  margin-top: 30px;
  padding: 28px;
  color: #6c6c6c;

  .ant-switch-checked {
    background-color: #2caf7a;
  }
}

.MFAImg {
  width: 200px;
  height: 200px;
}

.explain {
  // background-color: #fffbed;
  border: 1px solid #f9efd3;
  padding: 30px 30px 15px;
  line-height: 24px;
}

.download-app-image {
  width: 100px;
  height: 100px;
}

.download-url {
  display: flex;
  margin: 20px;
}

.image-div {
  text-align: center;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/SecuritySettingtab3.vue